import React, {useEffect, useState} from 'react';
import './App.css';
import Portfolio from "./components/Portfolio/Portfolio";
import Loader from "./components/Loader/Loader";

function App(): JSX.Element {
    const [loading, setLoading] = useState(true);

    useEffect((): void => {
        setTimeout((): void => {
            setLoading(false);
        }, 800);
    }, []);

    return (
      <>
          {loading &&
              <Loader />
          }
           <Portfolio />
      </>
  );
}

export default App;
